// Platform detection for OpenCSV.
//
// `isMobileApp()` returns true only when the React bundle is running inside
// the Capacitor Android (or future iOS) wrapper. In every regular browser it
// returns false — so the web experience at https://opencsv.io is unaffected.
//
// We use this to:
//  • hide marketing routes (Landing, Pricing, About, Blog, etc.)
//  • route unpaid users to /unlock (Google Play IAP) instead of Stripe Checkout
//  • simplify the nav

export function isMobileApp() {
    if (typeof window === "undefined") return false;
    try {
        // Capacitor 3+ exposes `Capacitor.isNativePlatform()`
        return Boolean(window.Capacitor?.isNativePlatform?.());
    } catch {
        return false;
    }
}

export function getNativePlatform() {
    if (typeof window === "undefined") return null;
    try {
        const cap = window.Capacitor;
        if (cap?.isNativePlatform?.()) return cap.getPlatform?.() || "unknown";
    } catch {/* ignore */ }
    return null;
}
